import { initialTree, TreeView, TreeViewNode } from '@fluid-experimental/tree';
import { MfsEdgeSetNode } from '.';
import { MfsCollectionKind } from '../..';
import {
  MfsValueNode,
  MfsReferenceNode,
  NodeKind,
  MfsItemNode,
  MfsCollectionNode,
  MfsItemNodeProperties,
  MfsEdgeNode,
  ITEMS,
  MfsMultiValueNode,
  MfsIndexNode,
} from './types';

/** Type guard that ensures a node is of the expected kind. */
export const isTypedNode = <T extends TreeViewNode>(node: TreeViewNode, expectedKind: NodeKind): node is T =>
  node.definition === expectedKind;

/** @ignore */
export const isItemNode = (node: TreeViewNode): node is MfsItemNode => isTypedNode<MfsItemNode>(node, NodeKind.Item);

/** @ignore */
export const isCollectionNode = (node: TreeViewNode): node is MfsCollectionNode =>
  isItemNode(node) && node.payload.kind === MfsCollectionKind.OrderedList;

/** @ignore */
export const isReferenceNode = (node: TreeViewNode): node is MfsReferenceNode =>
  isTypedNode<MfsReferenceNode>(node, NodeKind.Reference) && !!node.payload;

/** @ignore */
export const isEdgeNode = (node: TreeViewNode): node is MfsEdgeNode =>
  isTypedNode<MfsEdgeNode>(node, NodeKind.Edge) && !!node.payload;

/** @ignore */
export const isSingleValuePropertyNode = (node: TreeViewNode): node is MfsValueNode =>
  isTypedNode<MfsValueNode>(node, NodeKind.SingleValueNode) && node.payload !== undefined;

/** @ignore */
export const isMultiValuePropertyNode = (node: TreeViewNode): node is MfsMultiValueNode =>
  isTypedNode<MfsMultiValueNode>(node, NodeKind.Array);

/** @ignore */
export const isMultiValueNode = (node: TreeViewNode): node is MfsValueNode =>
  isTypedNode<MfsValueNode>(node, NodeKind.MultiValueNode) && node.payload !== undefined;

/** @ignore */
export const isEdgeSetNode = (node: TreeViewNode): node is MfsEdgeSetNode =>
  isTypedNode<MfsEdgeSetNode>(node, NodeKind.EdgeSet);

/** @ignore */
export const isIndexNode = (node: TreeViewNode): node is MfsIndexNode =>
  isTypedNode<MfsIndexNode>(node, NodeKind.Index) && !!node.payload;

/** @returns Whether the property is saved in the payload of an item node. */
export const isMfsItemNodeProperty = (propertyKey: string): propertyKey is keyof MfsItemNode['payload'] =>
  propertyKey in MfsItemNodeProperties;

/**
 * @returns Whether the node is the initial tree (view.rootNode) that contains the `items` trait which is the primary
 *   index of all items in store.
 */
export const isItemsRootNode = (view: TreeView, node: TreeViewNode): boolean =>
  node.identifier === view.root && node.definition === initialTree.definition && node.traits.has(ITEMS);
